// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  leaveRecords: [],
  totalLeaveRecords: 0,
}

export const mutations = {
  SET_LEAVE_RECORDS(state, leaveRecords) {
    state.leaveRecords = leaveRecords
  },
  SET_TOTAL_LEAVE_RECORDS(state, totalLeaveRecords) {
    state.totalLeaveRecords = totalLeaveRecords
  },
}

export const actions = {
  fetchLeaveRecords({ commit }, payload) {
    return ApiService.fetchLeaveRecords(payload)
      .then((res) => {
        const leaveRecords = res.data.data
        commit('SET_LEAVE_RECORDS', leaveRecords)
        commit('SET_TOTAL_LEAVE_RECORDS', res.data.total)
      })
      .catch((error) => {
        throw error
      })
  },
  leaveFileImport(_, payload) {
    return ApiService.leaveFileImport(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  leaveFileMigrationImport(_, payload) {
    return ApiService.leaveFileMigrationImport(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  leaveFileExport(_, payload) {
    return ApiService.leaveFileExport(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  leaveFileImportExample(_, payload) {
    return ApiService.leaveFileImportExample(payload)
      .then((res) => {
        const { url } = res.data
        return url
      })
      .catch((error) => {
        throw error
      })
  },
  leaveFileMigrationImportExample(_, payload) {
    return ApiService.leaveFileMigrationImportExample(payload)
      .then((res) => {
        const { url } = res.data
        return url
      })
      .catch((error) => {
        throw error
      })
  },
}
